<template>
  <div
    v-if="modelValue"
    class="risk-tier flex items-center justify-center px-3 py-1 text-xs font-semibold text-label"
    :class="{
      uppercase: uppercase,
      'rounded-full border border-gray-200': bordered,
    }"
  >
    <icon-base
      class="pb-0-5"
      height="18"
      width="16"
      :icon="'risk-tier-' + modelValue"
    />
    <span :class="{ '-ml-1': bordered }">{{ label }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

const store = useStore();

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: null,
  },
  uppercase: {
    type: Boolean,
    default: false,
  },
  bordered: {
    type: Boolean,
    default: false,
  },
});

const label = computed(() => {
  const riskTiers: Record<string, string> =
    store.getters["options/riskTiersMap"];
  return riskTiers[props.modelValue];
});
</script>

<style>
@reference "@/assets/tailwind.css";

table .risk-tier {
  @apply text-xxs;
}
</style>
